import { Datatype } from '../../../../datatype/Datatype.ts';
import { createConditionOperator } from '../../IConditionOperator.ts';
import {
  allowedFormats,
  isValueMatchingFormat,
} from './ConditionOperatorStringFormatUtils.ts';

export const ConditionOperatorStringMatchesFormatType = createConditionOperator(
  {
    code: 'stringMatchesFormat',
    label: 'è del formato',
    description: 'Corrisponde al formato',
    args: [
      {
        type: 'staticValue',
        field: {
          type: Datatype.String,
          label: 'Formato',
          options: [...allowedFormats],
        },
      },
    ] as const,
    allowsField: field => field.type === Datatype.String,
    compare(value: any, [target]: any[]) {
      return isValueMatchingFormat(value, target);
    },
  },
);
